import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
// Opcional: importar detector de idioma del navegador
import LanguageDetector from 'i18next-browser-languagedetector';

// <html lang> debe declarar el idioma real de la UI: con lang="en" sobre una UI en
// español, Chrome ofrece traducirla y «Planes» acaba como «Aviones» (#1681).
// Se registra antes de init() para cubrir también la detección inicial.
i18n.on('languageChanged', (lng) => {
  const current = i18n.resolvedLanguage || lng;
  if (current) document.documentElement.lang = current.split('-')[0];
});

i18n
  // Carga traducciones desde un backend (en este caso, la carpeta /public/locales)
  .use(HttpApi)
  // Detecta idioma del usuario (opcional, busca en localStorage, navegador, etc.)
  .use(LanguageDetector)
  // Pasa la instancia de i18n a react-i18next
  .use(initReactI18next)
  // Inicializa i18next
  .init({
    // Idioma a usar si la detección falla o el idioma detectado no está disponible
    fallbackLng: 'es',
    // Idiomas soportados
    supportedLngs: ['es', 'en'],
    // Activar logs de debug en desarrollo
    debug: process.env.NODE_ENV === 'development',

    // Opciones para react-i18next
    react: {
      useSuspense: true, // Usa React Suspense para la carga de traducciones
    },

    // React ya escapa HTML — desactivar el escape de i18next para evitar doble escape
    // en interpolaciones que contienen caracteres como < > &
    interpolation: {
      escapeValue: false,
    },

    // Opciones del backend de carga (i18next-http-backend)
    backend: {
      // Ruta donde encontrar los archivos JSON de traducción
      loadPath: '/locales/{{lng}}/{{ns}}.json', 
      // {{lng}} será reemplazado por 'es' o 'en'
      // {{ns}} será reemplazado por 'translation' (namespace por defecto)
    },

    // Opciones del detector de idioma (i18next-browser-languagedetector)
    detection: {
      // Orden y desde dónde detectar el idioma
      order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      // Clave a usar en localStorage
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng', 
    },
  });

export default i18n; 